import gql from "graphql-tag";
import PropTypes from "prop-types";
import { format, parse } from "date-fns";
import sortby from "lodash.sortby";

export default {
  query: gql`
    query cardTransactions(
      $sortById: SortField
      $sortByDate: SortField
      $cardId: ID!
      $dateFrom: DateTime!
      $dateTo: DateTime!
      $rowFrom: Int
      $rowTo: Int
      $transactionType: Int
      $isSuccessful: Boolean
    ) {
      cardTransactions(
        sortById: $sortById
        sortByDate: $sortByDate
        cardId: $cardId
        dateFrom: $dateFrom
        dateTo: $dateTo
        transactionType: $transactionType
        isSuccessful: $isSuccessful
        rowFrom: $rowFrom
        rowTo: $rowTo
      ) {
        id
        transactionId
        date
        device
        terminalId
        transactionCurrencyCode
        requestAmount
        billingAmount
        cardCurrencyCode
        authCode
        merchantName
        status
        statusName
        mcc
        type: operationName
        rrn
        fee
        smsStatus
        smsDate
        smsPhone
        isReversal
        hasReversal
        paymentSystem
        pan
        merchantCountry: country
        smsText
        companyId
        companyName
        acquiringId
        acquiringName
        originType: transactionType
        currentRow
        totalRows
      }
    }
  `,
  variables: ({
    cardId,
    dates,
    page = 1,
    itemsPerPage = 10,
    sortById,
    sortByDate,
    transactionType,
    isSuccessful,
  }) => {
    const firstItem = (page - 1) * itemsPerPage || 1;
    const lastItem = firstItem + itemsPerPage;
    const { startDate, endDate } = dates;
    return {
      sortById,
      sortByDate,
      cardId,
      dateFrom: format(startDate, "YYYY-MM-DDTHH:mm"),
      dateTo: format(endDate, "YYYY-MM-DDTHH:mm"),
      isSuccessful:
        typeof isSuccessful === "number" ? !!isSuccessful : undefined,
      transactionType,
      rowFrom: firstItem,
      rowTo: lastItem,
    };
  },
  config: {
    pollInterval: 0,
    errorPolicy: "none",
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  },
  propTypes: {
    cardId: PropTypes.string,
    dateFrom: PropTypes.instanceOf(Date),
    dateTo: PropTypes.instanceOf(Date),
    page: PropTypes.number,
    itemsPerPage: PropTypes.number,
  },
  dataKey: "cardTransactions",
  sort: (items) =>
    sortby(sortby(items, (o) => parseInt(o.id, 10)).reverse(), (o) =>
      parse(o.date)
    ).reverse(),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/cardTransactions.js